import { DeleteFilled } from "@ant-design/icons";
import { faCircleStop, faEye, faLock, faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "antd";
import SlideoutMenu from "components/atoms/SlideoutMenu";
import CypressTestIds from "../../../cypress/CypressTestIds";

interface IDuplicateDataObjectActionButtonsProps {
    job: IDataObjectsDuplicateJob;
    selected?: boolean;
    onViewData: (j: IDataObjectsDuplicateJob) => void;
    onDeleteJob: (j: IDataObjectsDuplicateJob) => void;
    onCancelJob: (id: string, version: string) => void;
    onRestartJob: (j: IDataObjectsDuplicateJob) => void;
}

export default function DuplicateDataObjectActionButtons({ job, selected = false, onViewData, onDeleteJob, onCancelJob, onRestartJob }: IDuplicateDataObjectActionButtonsProps) {
    return (
        <SlideoutMenu>
            {["COMPLETED", "CANCELLED", "FAILED"].includes(job.status) && (
                <Tooltip title="View Data">
                    <Button
                        type="link"
                        icon={<FontAwesomeIcon icon={faEye} />}
                        onClick={(event) => {
                            event && event.stopPropagation && event.stopPropagation();
                            onViewData(job);
                        }}
                        data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_LIST_VIEW_DATA_BUTTON}
                    />
                </Tooltip>
            )}
            {["CREATED", "RESTARTED", "RUNNING", "PENDING"].includes(job.status) && (
                <Tooltip title="Cancel Job">
                    <Button
                        type="link"
                        icon={<FontAwesomeIcon icon={faCircleStop} />}
                        onClick={(event) => {
                            event && event.stopPropagation && event.stopPropagation();
                            onCancelJob(job.jobId, job.version);
                        }}
                        data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_LIST_CANCEL_JOB_BUTTON}
                    />
                </Tooltip>
            )}
            {["COMPLETED", "CANCELLED", "FAILED"].includes(job.status) && (
                <Tooltip title="Run job again">
                    <Button
                        type="link"
                        icon={<FontAwesomeIcon icon={faPlayCircle} />}
                        onClick={(event) => {
                            event && event.stopPropagation && event.stopPropagation();
                            onRestartJob(job);
                        }}
                        data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_LIST_RUN_JOB_AGAIN_BUTTON}
                    />
                </Tooltip>
            )}
            <div className="block h-6 w-0 border-r border-dashed border-gray-300" />
            {!["COMPLETED", "CANCELLED", "FAILED"].includes(job.status) ? (
                <Tooltip placement="topLeft" title="A job is running. Job is locked for delete.">
                    <Button type="text" danger variant="text" icon={<FontAwesomeIcon icon={faLock} />} data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_LIST_DELETE_BUTTON} />
                </Tooltip>
            ) : (
                <Tooltip title="Delete Job" placement="topLeft">
                    <Button
                        type="text"
                        danger
                        icon={<DeleteFilled />}
                        onClick={(event) => {
                            event && event.stopPropagation && event.stopPropagation();
                            onDeleteJob(job);
                        }}
                        data-testid={CypressTestIds.DUPLICATE_SEARCH_CONFIG_LIST_DELETE_BUTTON}
                    />
                </Tooltip>
            )}
        </SlideoutMenu>
    );
}
